import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KNewsWidgetChipStyle } from './index.props.js';

var PREFIX = "KNewsColumnWidget";
var classes = {
    chip: "".concat(PREFIX, "-chip"),
    chipContainer: "".concat(PREFIX, "-chipContainer"),
    button: "".concat(PREFIX, "-button"),
    buttonIcon: "".concat(PREFIX, "-buttonIcon"),
    img: "".concat(PREFIX, "-image"),
    imageRow: "".concat(PREFIX, "-imageRow")
};
var StyledKNewsColumnWidget = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "imageUrl" &&
            prop !== "imageWidthAdaptation" &&
            prop !== "backgroundTextEffect" &&
            prop !== "backgroundTextColor" &&
            prop !== "verticalTextAlign" &&
            prop !== "isRowMode" &&
            prop !== "chip" &&
            prop !== "button" &&
            prop !== "backgroundColor" &&
            prop !== "borderColor" &&
            prop !== "borderRadius" &&
            prop !== "marginTop" &&
            prop !== "marginBottom";
    }
})(function (_a) {
    var _b, _c;
    var _d;
    var imageUrl = _a.imageUrl, imageWidthAdaptation = _a.imageWidthAdaptation, isRowMode = _a.isRowMode, theme = _a.theme, chip = _a.chip, button = _a.button, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderRadius = _a.borderRadius, marginTop = _a.marginTop, marginBottom = _a.marginBottom;
    return (__assign(__assign(__assign(__assign({ display: "flex", width: "100%", flexDirection: isRowMode ? "row" : "column", backgroundColor: backgroundColor }, (borderColor && { border: "1px solid ".concat(borderColor) })), { overflow: "hidden", borderRadius: borderRadius, marginTop: marginTop || "unset", marginBottom: marginBottom || "unset" }), (borderColor && { border: "1px solid ".concat(borderColor) })), (_b = {}, _b[theme.breakpoints.down("md")] = {
        flexDirection: "column"
    }, _b["& .".concat(classes.chipContainer)] = { display: "flex" }, _b["& .".concat(classes.chip)] = {
        borderRadius: (_d = chip === null || chip === void 0 ? void 0 : chip.borderRadius) !== null && _d !== void 0 ? _d : theme.shape.borderRadius,
        backgroundColor: (chip === null || chip === void 0 ? void 0 : chip.style) === KNewsWidgetChipStyle.Filled ? chip === null || chip === void 0 ? void 0 : chip.color : chip === null || chip === void 0 ? void 0 : chip.backgroundColorOutlined,
        borderColor: chip === null || chip === void 0 ? void 0 : chip.color,
        color: chip === null || chip === void 0 ? void 0 : chip.labelColor
    }, _b["& .".concat(classes.button)] = __assign(__assign(__assign(__assign(__assign(__assign({}, ((button === null || button === void 0 ? void 0 : button.borderRadius) && { borderRadius: button === null || button === void 0 ? void 0 : button.borderRadius })), ((button === null || button === void 0 ? void 0 : button.backgroundColor) && { backgroundColor: button === null || button === void 0 ? void 0 : button.backgroundColor })), ((button === null || button === void 0 ? void 0 : button.borderColor) && { border: "1px solid ".concat(button === null || button === void 0 ? void 0 : button.borderColor) })), ((button === null || button === void 0 ? void 0 : button.size) && { width: button === null || button === void 0 ? void 0 : button.size })), (((button === null || button === void 0 ? void 0 : button.hoverColor) || (button === null || button === void 0 ? void 0 : button.backgroundColor)) && {
        "&:hover": {
            backgroundColor: (button === null || button === void 0 ? void 0 : button.hoverColor)
                ? "".concat(button === null || button === void 0 ? void 0 : button.hoverColor, " !important")
                : "".concat(button === null || button === void 0 ? void 0 : button.backgroundColor, " !important"),
            filter: (button === null || button === void 0 ? void 0 : button.hoverColor) ? "" : "brightness(85%)"
        }
    })), ((button === null || button === void 0 ? void 0 : button.labelColor) && { color: button === null || button === void 0 ? void 0 : button.labelColor })), _b["& .".concat(classes.buttonIcon)] = {
        paddingTop: "3px"
    }, _b["& .".concat(classes.imageRow)] = (_c = {
            width: "50%"
        },
        _c[theme.breakpoints.down("md")] = {
            width: "100%"
        },
        _c), _b["& .".concat(classes.img)] = {
        backgroundSize: "cover",
        backgroundImage: "url(\"".concat(imageUrl, "\")"),
        backgroundPosition: "center",
        height: isRowMode ? "100%" : imageWidthAdaptation ? "0" : "50%",
        paddingTop: imageWidthAdaptation ? "50%" : "unset"
    }, _b)));
});

export { classes, StyledKNewsColumnWidget as default };
//# sourceMappingURL=index.column.styled.js.map
